import type { UserContextData } from "@types_def/models/user.type";
import type { Dispatch, SetStateAction } from "react";

import React, { use } from "react";

export type UserContextContent = {
  userState: UserContextData | undefined;
  handleSetUser: (user: UserContextData | undefined) => void;
  keyword: string;
  setKeyword: Dispatch<SetStateAction<string>>;
};

export const UserContext = React.createContext<UserContextContent>({
  userState: undefined,
  handleSetUser() {},
  setKeyword() {},
  keyword: "",
});

export const useUserContext = () => use(UserContext);
